export const isHoursOverBudget = (totals) => {
  return parseFloat(totals?.remaining_percent_hour) < 0;
};

export const isCostOverBudget = (totals) =>
  totals?.remaining_percent_of_estimate !== undefined
    ? parseFloat(totals.remaining_percent_of_estimate) < 0
    : parseFloat(totals?.remaining_percent) < 0;
